import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/rentals',
    name: 'Rental',
    component: {
      name: 'AdminRental',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'rental',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminRentalIndex',
        component: () => import('../views/RentalIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminRentalNew',
        component: () => import('../views/RentalInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminRentalIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminRentalShow',
        component: () => import('../views/RentalShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminRentalIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminRentalDetails',
            component: () => import('../views/RentalDetails.vue'),
            meta: {
              backRoute: { name: 'AdminRentalIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminRentalEdit',
            component: () => import('../views/RentalInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminRentalDetails' },
            },
          },
          {
            path: 'edit_assigned_resources',
            name: 'AdminRentalAssignedResourcesEdit',
            component: () => import('../views/RentalAssignedResourcesInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminRentalDetails' },
            },
          },
          /* ------- Rental Lines Tab ------- */
          {
            path: 'rental_lines',
            name: 'AdminRentalRentalLines',
            component: {
              name: 'AdminRentalLine',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminRentalIndex' },
              resource: 'rental_line',
            },
            children: [
              {
                path: '',
                name: 'AdminRentalLines',
                component: () => import('../views/RentalLines/RentalLinesIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminRentalIndex' },
                },
              },              
              {
                path: 'new',
                name: 'AdminRentalLineNew',
                component: () => import('../views/RentalLines/RentalLineInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminRentalIndex' },
                },
              },
              {
                path: ':rentalLineId(\\d+)',
                name: 'AdminRentalLineShow',
                component: () => import('../views/RentalLines/RentalLineShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminRentalLines',
                  },
                  tArgs: route => ({ name: route.params?.rentalLineId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminRentalLineDetails',
                    component: () => import('../views/RentalLines/RentalLineDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminRentalLines' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminRentalLineEdit',
                    component: () => import('../views/RentalLines/RentalLineInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminRentalLines' },
                    },
                  },
                ]
              }
            ],
          },
          {
            path: 'attachments',
            name: 'AdminRentalAttachments',
            component: () => import('../views/RentalAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminRentalIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminRentalAttachmentsEdit',
            component: () => import('../views/RentalAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminRentalAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'rental_line_particularities',
            name: 'AdminRentalRentalLineParticularities',
            component: {
              name: 'AdminRentalLineParticularity',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminRentalIndex' },
              resource: 'rental_line_particularity',
            },
            children: [
              {
                path: '',
                name: 'AdminRentalLineParticularities',
                component: () => import('../views/RentalLineParticularities/RentalLineParticularitiesIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminRentalIndex' },
                },
              },              
              {
                path: 'new',
                name: 'AdminRentalLineParticularityNew',
                component: () => import('../views/RentalLineParticularities/RentalLineParticularityInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminRentalIndex' },
                },
              },
              {
                path: ':rentalLineParticularityId(\\d+)',
                name: 'AdminRentalLineParticularityShow',
                component: () => import('../views/RentalLineParticularities/RentalLineParticularityShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminRentalLines',
                  },
                  tArgs: route => ({ name: route.params?.rentalLineParticularityId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminRentalLineParticularityDetails',
                    component: () => import('../views/RentalLineParticularities/RentalLineParticularityDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminRentalLineParticularities' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminRentalLineParticularityEdit',
                    component: () => import('../views/RentalLineParticularities/RentalLineParticularityInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminRentalLineParticularities' },
                    },
                  },
                ]
              }
            ]
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));